<template>
  <div style="display: flex;">
    <!-- 左侧菜单栏   -->
    <div :style="{width:(isCollapse ? '64px' : '208px')}">
      <el-menu
            style="width:100%;height:100vh;"
            background-color="#366ba0"
            text-color="#fff"
            active-text-color="#ff0"
            router
            unique-opened
            :collapse="isCollapse"
            :collapse-transition="false">
        <el-row style="padding-top: 10px;">
          <el-col :span="2"></el-col>
          <el-col :span="7" style="padding-left: 7px;">
            <el-avatar src="/imgs/logoCricle.png"
                       style="width: 35px;height: 35px;"></el-avatar>
          </el-col>
          <el-col :span="isCollapse ? 0 :13 ">
            <span style="color:#fff;font-weight: bold;position:relative;top:8px;left:2px;">
              在线考试平台</span>
          </el-col>
        </el-row>

        <!-- 动态渲染过滤后的菜单 -->
        <el-menu-item v-for="menu in filteredMenus" :key="menu.index" :index="menu.index">
          <el-icon style="font-size: 22px;">
            <!-- 直接使用menu.icon，因为它已经是组件对象了 -->
            <component :is="menu.icon"></component>
          </el-icon>
          <template #title>{{ menu.title }}</template>
        </el-menu-item>
      </el-menu>
    </div>




    <!-- 右侧主体内容   -->
    <div :style="{width:(isCollapse ? 'calc(100% - 64px)' : 'calc(100% - 208px)')}">
      <el-header style="height:10vh;background-color:#fff;padding:22px 0 0 20px;">
        <!-- 折叠图标+登录人姓名下拉菜单(退出登录) -->
        <el-row :gutter="10">
          <el-col :span="18">
            <el-icon style="font-size: 21px;" @click="changeCollapsed"><Expand/></el-icon>
          </el-col>
          <el-col :span="6" style="position: relative;">
            <el-dropdown style="position: absolute;right: 20px;" trigger="click">
              <span style="font-size: 19px;font-weight: bold;">
                {{user?.trueName || user?.username || '未登录'}}
                <el-icon><ArrowDown /></el-icon>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item @click="logout">退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </el-col>
        </el-row>
      </el-header>
      <!-- 右侧主体区域 -->
      <el-main style="height: 90vh;padding: 0;overflow-y:scroll;">
        <router-view/>
      </el-main>
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref, computed} from "vue";
import {useRoute, useRouter} from "vue-router";
import {Avatar, Printer, Collection, Document, Edit, FolderOpened, House, Lock, Notebook, Search, Odometer, User, UserFilled, ArrowDown} from "@element-plus/icons-vue";
import UserUtil from "../constants/user";
import { MENU_CONFIG, getRolesForRoute } from "../constants/permissions";

//定义变量用来控制左侧菜单栏是否折叠
const isCollapse = ref(false);
//定义方法修改菜单栏的折叠状态
const changeCollapsed = () => {
  isCollapse.value = !isCollapse.value;
};

//获取当前登录的用户数据
const user = ref(UserUtil.getCurrentUser());

// 组件挂载时获取最新的用户信息
onMounted(() => {
  user.value = UserUtil.getCurrentUser();
});
//定义退出登录的方法
const logout = ()=>{
  if(confirm('您确认要退出登录吗?')){
    //删除保存在localStorage中的登录用户数据
    localStorage.removeItem('user');
    localStorage.removeItem('currentUser');
    //跳转至登录页面
    window.location.href = '/login';
    //清空当前登录用户数据
    user.value = '';
  }
}
//useRoute()是vue路由器提供的一个方法,用来获取当前组件的路由对象
const route = useRoute();

// 图标组件映射
const iconComponents = {
  House,
  Collection,
  Edit,
  FolderOpened,
  Document,
  Search,
  Notebook,
  Odometer,
  Avatar,
  User,
  Lock,
  Printer,
  UserFilled
};

// 检查图标映射
console.log('Icon components mapping:', iconComponents);
console.log('MENU_CONFIG:', MENU_CONFIG);

// 根据用户角色过滤可用菜单
const filteredMenus = computed(() => {
  // 使用当前用户信息进行菜单过滤
  if (!user.value || !user.value.roleId) {
    return [];
  }

  const userRole = user.value.roleId;

  // 直接处理菜单数据，避免JSON深拷贝破坏组件对象
  return MENU_CONFIG.filter(menu => {
    // 获取菜单项的角色权限
    const roles = getRolesForRoute(menu.index);
    // 检查用户角色是否在允许列表中
    return roles.includes(userRole);
  }).map(menu => ({
    ...menu,
    // 直接获取图标组件，不进行深拷贝
    icon: iconComponents[menu.icon] || House // 确保有默认图标
  }));
});
</script>
